module.exports = __webpack_public_path__ + "media/src/images/logo-full-light-bg-6081cfc3c98aefbfeaaa9fd1b544463c.svg";